import type { Company } from "@/models/company";
import axios from "axios";

export const registerDefaultCompany = async (
  company: Company
): Promise<Company> => {
  const response = await axios.post("/api/company/register-default", company);
  return response.data;
};

export const searchCompany = async (searchText: string): Promise<Company[]> => {
  const searchRequest = new CompanySearchRequest(
    SearchType.FullSearch,
    searchText
  );

  const response = await axios.post("api/companies/search", searchRequest);
  return response.data;
};

export const suggestCompany = async (
  searchText: string
): Promise<Company[]> => {
  const searchRequest = new CompanySearchRequest(
    SearchType.Suggestion,
    searchText
  );

  const response = await axios.post("api/companies/search", searchRequest);
  return response.data;
};

class CompanySearchRequest {
  searchType: SearchType;
  searchText: string;

  constructor(type: SearchType, text: string) {
    this.searchType = type;
    this.searchText = text;
  }
}

enum SearchType {
  FullSearch = "FullSearch",
  Suggestion = "Suggestion",
}
